<script type="text/javascript">
  export default {
  };
</script>

<template>
  <div class="market-shares-item-loader">
    <div class="market-shares-item-loader__image">

    </div>
    <div class="market-shares-item-loader__content">
      <div class="market-shares-item-loader__text"></div>
    </div>
  </div>
</template>

<style lang="scss">
  @import '~styles/settings';

  .market-shares-item-loader {
    display: flex;
    height: 81px;
    background: $white;
    margin-bottom: 10px;

    &__image {
      width: 130px;
      background: linear-gradient(307deg, #07414b, #083037);
    }

    &__content {
      padding: 20px;
    }

    &__text {
      height: 15px;
      opacity: 0.4;
      background-color: $blue2;
      width: 150px;

      @include breakpoint($layout-breakpoint) {
        width: 217px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content-loader/MarketSharesItemLoader.vue